import { render, staticRenderFns } from "./ChooseGoodsItem.vue?vue&type=template&id=05284f56&scoped=true&"
import script from "./ChooseGoodsItem.vue?vue&type=script&lang=js&"
export * from "./ChooseGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoodsItem.vue?vue&type=style&index=0&id=05284f56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05284f56",
  null
  
)

export default component.exports